// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"79":"group-permissions","789":"messaging","806":"user"}[chunkId] || chunkId) + "." + {"30":"b9ed4f1a","79":"4ed7312b","789":"faef9145","806":"a5f7a9d7"}[chunkId] + ".css";
};